module.exports = __webpack_public_path__ + "media/images/icons/check-a395fb90556f69d9a240507e0738f02c.png";